<template>
  <div class="row g-3">
    <div
      class="col-md-6"
      :class="{
        'field-required': validationObject.locationObject.address.$invalid,
      }"
    >
      <!--Local (obrigatório);-->
      <label :for="getLabelIdentifier('address')" class="form-label"
        >Local</label
      >
      <InputText
        :id="getLabelIdentifier('address')"
        v-model="locationObject.address"
        class="form-control"
      />
    </div>
    <div
      class="col-md-6"
      :class="{
        'field-required': validationObject.locationObject.number.$invalid,
      }"
    >
      <!--Nº (obrigatório);-->
      <label :for="getLabelIdentifier('number')" class="form-label">Nº</label>
      <InputText
        :id="getLabelIdentifier('number')"
        v-model="locationObject.number"
        class="form-control"
      />
    </div>
    <div
      class="col-md-12"
      :class="{
        'field-required': validationObject.locationObject.countryId.$invalid,
      }"
      v-if="showCountrySelector"
    >
      <!--País (obrigatório);-->
      <label :for="getLabelIdentifier('country')" class="form-label"
        >País</label
      >
      <Dropdown
        :id="getLabelIdentifier('country')"
        v-model="locationObject.countryId"
        :options="countries"
        optionLabel="Description"
        optionValue="Id"
        :filter="true"
        :placeholder="loading.countries ? 'Carregando...' : 'Selecione País'"
        :showClear="true"
        :disabled="!showCountrySelector"
        class="form-control"
        :loading="countries.length === 0"
        @change="onCountryChange"
      />
    </div>
    <div
      class="col-md-4"
      v-if="isBrasilSelected"
      :class="{
        'field-required': validationObject.locationObject.stateId.$invalid,
      }"
    >
      <!--Estado (obrigatório dado que preencha o país Brasil, uma lista deverá se apresentado);-->
      <label :for="getLabelIdentifier('stateDrop')" class="form-label"
        >Estado</label
      >
      <Dropdown
        :id="getLabelIdentifier('stateDrop')"
        v-model="locationObject.stateId"
        :options="states"
        optionLabel="Description"
        optionValue="Id"
        :placeholder="loading.states ? 'Carregando...' : 'Selecione Estado'"
        :filter="true"
        :showClear="true"
        class="form-control"
        :loading="loading.states || states.length === 0"
        @change="onStateChange"
        :disabled="!locationObject.countryId"
      />
    </div>
    <div
      class="col-md-4"
      v-else
      :class="{
        'field-required':
          validationObject.locationObject.stateDescription.$invalid,
      }"
    >
      <!--Estado (obrigatório dado que preencha o país Brasil, uma lista deverá se apresentado);-->
      <label :for="getLabelIdentifier('stateText')" class="form-label"
        >Estado</label
      >
      <InputText
        :id="getLabelIdentifier('stateText')"
        v-model="locationObject.stateDescription"
        class="form-control"
      />
    </div>
    <div
      class="col-md-4"
      v-if="isBrasilSelected"
      :class="{
        'field-required': validationObject.locationObject.cityId.$invalid,
      }"
    >
      <!--Cidade (obrigatório);-->
      <label :for="getLabelIdentifier('cityDrop')" class="form-label"
        >Cidade</label
      >
      <Dropdown
        :id="getLabelIdentifier('cityDrop')"
        v-model="locationObject.cityId"
        :options="cities"
        optionLabel="Description"
        optionValue="Id"
        :filter="true"
        :placeholder="loading.cities ? 'Carregando...' : 'Selecione Cidade'"
        :showClear="true"
        class="form-control"
        :loading="loading.cities || cities.length === 0"
        @change="onCityChange"
        :disabled="!locationObject.stateId"
      />
    </div>
    <div
      class="col-md-4"
      v-else
      :class="{
        'field-required':
          validationObject.locationObject.cityDescription.$invalid,
      }"
    >
      <!--Cidade (obrigatório);-->
      <label :for="getLabelIdentifier('cityText')" class="form-label"
        >Cidade</label
      >
      <InputText
        :id="getLabelIdentifier('cityText')"
        v-model="locationObject.cityDescription"
        class="form-control"
      />
    </div>
    <div
      class="col-md-4"
      v-if="isBrasilSelected"
      :class="{
        'field-required': validationObject.locationObject.localityId.$invalid,
      }"
    >
      <!--Bairro (obrigatório);-->
      <label :for="getLabelIdentifier('localityDrop')" class="form-label"
        >Bairro</label
      >
      <Dropdown
        :id="getLabelIdentifier('localityDrop')"
        v-model="locationObject.localityId"
        :options="localities"
        optionLabel="Description"
        optionValue="Id"
        :placeholder="loading.localities ? 'Carregando...' : 'Selecione Bairro'"
        :filter="true"
        :showClear="true"
        class="form-control"
        :loading="loading.localities || localities.length === 0"
        :disabled="!locationObject.cityId"
        @change="onLocalityChange"
      />
    </div>
    <div
      v-else
      class="col-md-4"
      :class="{
        'field-required':
          validationObject.locationObject.localityDescription.$invalid,
      }"
    >
      <!--Bairro (obrigatório);-->
      <label :for="getLabelIdentifier('localityText')" class="form-label"
        >Bairro</label
      >
      <InputText
        :id="getLabelIdentifier('localityText')"
        v-model="locationObject.localityDescription"
        class="form-control"
      />
    </div>
    <div class="col-md-12">
      <!--Complemento (facultativo);-->
      <label :for="getLabelIdentifier('complement')" class="form-label"
        >Complemento</label
      >
      <InputText
        :id="getLabelIdentifier('complement')"
        v-model="locationObject.complement"
        class="form-control"
      />
    </div>
    <slot name="otherFields"></slot>
  </div>
  <!--Local (obrigatório);-->
  <!--Nº (obrigatório);-->
  <!--País (obrigatório);-->
  <!--Estado (obrigatório dado que preencha o país Brasil, uma lista deverá se apresentado);-->
  <!--Cidade (obrigatório);-->
  <!--Bairro (obrigatório);-->
  <!--Complemento (facultativo);-->
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { getCities, getParish } from '../../api/formMethods';
import GenericLocation from '../../utils/classes/GenericLocation';
import { locationDefaultObject } from '../../utils/constants';

export default {
  props: {
    value: {
      type: GenericLocation,
      default: () => new GenericLocation(locationDefaultObject),
    },
    showCountrySelector: {
      type: Boolean,
      default: true,
      required: false,
    },
    defaultCountry: {
      type: Object,
      required: false,
    },
    showComplementInput: {
      type: Boolean,
      default: true,
    },
    validationObject: {
      type: Object,
      required: true,
    },
    locationSectionName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      brasilCountryId: 3,
      locationObject: this.value,
      loading: {
        countries: false,
        states: false,
        cities: false,
        localities: false,
      },
      cities: [],
      localities: [],
    };
  },
  created() {
    // Garante que o campo number (número) esteja inicializado
    if (this.locationObject && this.locationObject.number === undefined) {
      this.locationObject.number = '';
    }
  },
  computed: {
    ...mapGetters({
      countries: 'getCountries',
      statesBrasil: 'getStatesBrasil',
    }),
    isBrasilSelected() {
      // Caso selecionado o país Brasil, o campo Estado deve ser obrigatório.
      return this.locationObject.countryId === this.brasilCountryId;
    },
    states() {
      return this.statesBrasil;
    },
  },
  mounted() {
    this.loading.countries = true;
    this.getOrSetCountries();
    this.loading.countries = false;

    if (this.defaultCountry) {
      this.locationObject.countryId = this.defaultCountry.Id;
      this.locationObject.countryDescription = this.defaultCountry.Description;
    }
  },
  watch: {
    locationObject: {
      async handler(newLocation) {
        this.$emit('locationUpdated', this.locationObject);
        if(newLocation.cityId && newLocation.localityId && (!this.cities || !this.cities.find((c)=> c.Id == newLocation.cityId))){

          this.loading.cities = true;
          this.loading.localities = true;

          // get cities
          this.cities = await getCities(this.locationObject.stateId);
          this.localities = await getParish(this.locationObject.cityId);

          this.loading.cities = false;
          this.loading.localities = false;
        }
      },
      deep: true,
    },
    defaultCountry: {
      handler(newVal) {
        if (newVal) {
          this.locationObject.countryId = newVal.Id;
          this.locationObject.countryDescription = newVal.Description;
          console.log('defaultCountry applied', newVal);
        }
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions(['getOrSetCountries', 'getOrSetStatesBrasil']),
    async onCountryChange() {
      if (!this.locationObject.countryId) {
        this.locationObject.countryDescription = undefined;
        this.clearSelectedState();
        this.clearSelectedCity();
        this.clearSelectedLocality();
        return;
      }

      this.locationObject.countryDescription = this.countries.find(
        (country) => country.Id === this.locationObject.countryId
      ).Description;

      this.loading.states = true;
      this.loading.cities = true;
      this.loading.localities = true;

      if (this.isBrasilSelected) this.getOrSetStatesBrasil();

      this.clearSelectedState();
      this.clearSelectedCity();
      this.clearSelectedLocality();

      this.loading.states = false;
      this.loading.cities = false;
      this.loading.localities = false;
    },
    async onStateChange() {
      if (!this.locationObject.stateId) {
        this.clearSelectedState();
        this.clearSelectedCity();
        this.clearSelectedLocality();
        return;
      }

      this.locationObject.stateDescription = this.states.find(
        (state) => state.Id === this.locationObject.stateId
      ).Description;

      this.loading.cities = true;
      this.loading.localities = true;

      this.clearSelectedCity();
      this.clearSelectedLocality();

      // get cities
      this.cities = await getCities(this.locationObject.stateId);

      this.loading.cities = false;
      this.loading.localities = false;
    },
    async onCityChange() {
      if (!this.locationObject.cityId) {
        this.clearSelectedCity();
        this.clearSelectedLocality();
        return;
      }

      this.locationObject.cityDescription = this.cities.find(
        (city) => city.Id === this.locationObject.cityId
      ).Description;

      this.loading.localities = true;

      this.clearSelectedLocality();

      // get localities
      this.localities = await getParish(this.locationObject.cityId);

      this.loading.localities = false;
    },
    onLocalityChange() {
      if (!this.locationObject.localityId) {
        this.clearSelectedLocality();
        return;
      }

      this.locationObject.localityDescription = this.localities.find(
        (locality) => locality.Id === this.locationObject.localityId
      ).Description;
    },
    clearSelectedState() {
      this.locationObject.stateId = undefined;
      this.locationObject.stateDescription = undefined;
    },
    clearSelectedCity() {
      this.locationObject.cityId = undefined;
      this.locationObject.cityDescription = undefined;
    },
    clearSelectedLocality() {
      this.locationObject.localityId = undefined;
      this.locationObject.localityDescription = undefined;
    },
    getLabelIdentifier(label) {
      return `${this.locationSectionName}-${label}`;
    },
  },
};
</script>

<style></style>
